import { useCallback } from 'react'
import { buildAnalyticsLink } from '@/utils/AnalyticsLinkBuilder'
import { useSafeTrack } from '@/utils/analytics'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export function useYoungWashingtonTickets() {
  const track = useSafeTrack()
  const { asPath } = useSafeRouter()

  const handleBuyTicketsClick = useCallback(
    async (location: string) => {
      await track('Preorder 15 Dollar Ticket Clicked', {
        projectSlug: 'young-washington',
        location,
        price: 15,
        currency: 'USD',
      })

      const url = buildAnalyticsLink({
        href: 'https://shop.angel.com/products/young-washington-15-00-ticket-preorder-now',
        path: asPath,
        campaign: 'young-washington-preorder',
        linkContext: `${location}-buy-tickets`,
      })

      window.location.href = url
    },
    [track, asPath],
  )

  return { handleBuyTicketsClick, ctaText: 'Pre-Order Tickets' }
}
